/**
 * Composant - HighAmountWarning
 *
 * Fenêtre de confirmation pour les retraits d'un montant élevé.
 * Demande une confirmation explicite avant de procéder.
 */

import { AlertTriangle, Check, Edit2 } from 'lucide-react';
import { formatAmount, WITHDRAWAL_THRESHOLDS } from '../types';
import { montantEnLettres } from '../../../../shared/utils/montantEnLettres';
import '../etapes.css';

interface HighAmountWarningProps {
  amount: number;
  onConfirm: () => void;
  onModify: () => void;
  isVisible: boolean;
}

export function HighAmountWarning({ amount, onConfirm, onModify, isVisible }: HighAmountWarningProps) {
  if (!isVisible) return null;

  const requiresSupervisor = amount >= WITHDRAWAL_THRESHOLDS.supervisorRequired;

  return (
    <div className="et-voile" role="dialog" aria-modal="true" aria-labelledby="titre-montant-eleve">
      <div className="et-modale">
        <header className="et-entete">
          <span className="ico ambre">
            <AlertTriangle />
          </span>
          <div>
            <h2 id="titre-montant-eleve">Confirmer un montant élevé</h2>
            <p>Au-delà de {formatAmount(WITHDRAWAL_THRESHOLDS.highAmountWarning)}</p>
          </div>
        </header>

        <div className="et-corps">
          <div className="et-montant">
            <p className="lib">Montant à remettre</p>
            <p className="val">{formatAmount(amount)}</p>
            <p className="lettres">{montantEnLettres(amount)}</p>
          </div>

          {requiresSupervisor && (
            <div className="et-note erreur">
              <AlertTriangle />
              <p>Une validation superviseur est requise pour ce montant.</p>
            </div>
          )}

          <div className="et-note alerte">
            <AlertTriangle />
            <div>
              <strong>Avant de confirmer, vérifiez :</strong>
              <ul>
                <li>le montant et le détail des coupures ;</li>
                <li>l&apos;identité du client et sa pièce ;</li>
                <li>que vous êtes autorisé à servir ce montant.</li>
              </ul>
            </div>
          </div>

          <div className="et-btns">
            <button type="button" onClick={onModify} className="et-btn secondaire">
              <Edit2 />
              Modifier
            </button>
            <button type="button" onClick={onConfirm} className="et-btn ambre large">
              <Check />
              Confirmer le retrait
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
